import { animated } from '#app/components/Primitives/Animated.js';
import { type ShapeProps } from '#app/components/Shapes/types.js';
import { SvgGradient } from '#app/components/SvgGradient/SvgGradient.js';
import { useLinearGradientDetails } from '#app/hooks/useLinearGradientDetails.js';

const Stairs = ({ gradient, type, ...props }: ShapeProps) => {
  const { id, url } = useLinearGradientDetails();

  return (
    <animated.svg
      viewBox="0 0 155 134"
      {...props}
    >
      <SvgGradient
        id={id}
        {...gradient}
      />
      <path
        d="M155 134H0V73.676h21.235V36.838h20.347V0H155v134z"
        fill={type === 'fill' ? url : 'none'}
        stroke={type === 'stroke' ? url : 'none'}
      />
    </animated.svg>
  );
};

export default Stairs;
